/* jshint esversion: 6 */

$(document).ready(function() {
  initResizeEvents();
  initMainTabs();
  initFixedHeaderScrollAction();
  initPopupLoginPanel();
  initSidebarExpandableFilters();
  initSummernote();
  initAdButtons();
  initArticleSummernote();
});

function initResizeEvents() {
  handleResize();
  $(window).on("resize", function(e) {
    handleResize();
  });
}

function handleResize() {
  if ($(window).innerWidth() >= 992) {
    $(".cat-expandable-sidebar").css("display", "block");
  } else {
    $(".cat-expandable-sidebar").css("display", "none");
  }
}

function initMainTabs() {
  initTabExpander();
  initTabSwitcher();
}

function initTabExpander() {
  $(".tabs-more a").on("click", function(e) {
    e.preventDefault();
    $(".tabs-more-list")
      .stop(true, true)
      .slideToggle("fast");
  });
}

function initTabSwitcher() {
  $(".switcher-item").on("click", function(e) {
    e.preventDefault();
    var self = $(this);
    var target = "#" + $(self).attr("data-target");

    if (!$(self).hasClass("active") && !$(self).hasClass("locked")) {
      $(".switcher-item").addClass("locked");
      $(".tabs-item.active")
        .stop(true, true)
        .fadeOut()
        .promise()
        .done(function() {
          $(".switcher-item.active").removeClass("active");
          $(".tabs-item.active").removeClass("active");
          $(target)
            .fadeIn()
            .promise()
            .done(function() {
              $(target).addClass("active");
              $(self).addClass("active");
              $(".switcher-item").removeClass("locked");
            });
        });

      $(".tabs-more-list-row.active")
        .stop(true, true)
        .fadeOut()
        .promise()
        .done(function() {
          $(".tabs-more-list-row.active").removeClass("active");
          $(target + "-more")
            .fadeIn()
            .promise()
            .done(function() {
              $(target + "-more").addClass("active");
            });
        });
    }
  });
}

function initFixedHeaderScrollAction() {
  $(window).on("scroll", function(e) {
    handleHeaderBarBackground();
  });

  handleHeaderBarBackground();
}

function handleHeaderBarBackground() {
  var header = $(".header");

  if ($(window).scrollTop() > 100 && !$(header).hasClass("header--scrolled")) {
    $(header).addClass("header--scrolled");
  } else if (
    $(window).scrollTop() < 100 &&
    $(header).hasClass("header--scrolled")
  ) {
    $(header).removeClass("header--scrolled");
  }
}

const toast = swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

function initPopupLoginPanel() {
  $("#header__login").on("click", async function(e) {
    e.preventDefault();
    var href = $(this).attr("href");
    var token = $('meta[name="csrf-token"]').attr("content");
    var loginRoute = href + "/login";

    const { value: formValues } = await swal({
      title: "Logowanie",
      showCloseButton: true,
      showLoaderOnConfirm: true,
      html:
        '<div class="header-pop-form">' +
        "<hr />" +
        '<label for="login-pop-uname">Adres e-mail</label>' +
        '<input id="login-pop-username" name="email" class="swal2-input" type="text" placeholder="Adres e-mail">' +
        '<label for="login-pop-pass">Hasło</label>' +
        '<input id="login-pop-password" name="password" class="swal2-input" type="password" placeholder="Hasło">' +
        "<hr />" +
        '<a href="' +
        href +
        '/rejestracja"><strong>Nowe konto</strong></a> <br /> <a href="' +
        href +
        '/haslo/reset">Nie pamiętam hasła</a>' +
        "</div>",

      focusConfirm: false,
      preConfirm: () => {
        var data = {
          _token: token,
          email: $("#login-pop-username").val(),
          password: $("#login-pop-password").val()
        };

        return fetch(loginRoute, {
          body: JSON.stringify(data),
          credentials: "same-origin",
          headers: {
            "content-type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-TOKEN": token
          },
          method: "POST"
        })
          .then(response => {
            if (!response.ok) {
              if (response.status == 401) {
                swal.showValidationError(
                  `Podane dane nie pasują do żadnego konta.`
                );
              } else {
                throw new Error(response.statusText);
              }
            } else {
              return response.json();
            }
          })
          .catch(error => {
            swal.showValidationError(
              `<a href="` +
                href +
                `/logowanie">Próba logowania nieudana. <br />Jeśli błąd się powtarza użyj<br /><span>standardowego panelu logowania</span></a>`
            );
          });
      },
      allowOutsideClick: () => !swal.isLoading()
    });

    if (formValues) {
      appendUserPanel(href);
      toast({
        type: "success",
        title: "Zalogowano!"
      });
      window.location.href = `${href}/panel`;
    }
  });
}

function appendUserPanel(href) {
  $("#header__login")
    .remove()
    .promise()
    .done(function() {
      $(".header__login").append(
        '<a id="header-userpanel" href="' +
          href +
          '/panel"><i class="fa fa-user d-block d-sm-none"></i> <span class="d-none d-sm-block">Panel użytkownika</span></a>'
      );
    });

  $("#header__register")
    .remove()
    .promise()
    .done(function() {
      $(".header__add").append(
        '<a href="' +
          href +
          '/panel/ogloszenia/dodaj"><i class="fa fa-plus d-block d-sm-none"></i> <span class="d-none d-sm-block">Dodaj ogłoszenie</span></a>'
      );
    });
}

function initSidebarExpandableFilters() {
  $(".cat-filter-expand").on("click", function(e) {
    e.preventDefault();
    $(".cat-expandable-sidebar")
      .stop(true, true)
      .slideToggle();
  });
}

function initSummernote() {
  $(".summernote").summernote({
    height: 300,
    placeholder: "Treść Twojego ogłoszenia...",
    lang: "pl-PL",
    minHeight: 300,
    maxHeight: null,
    disableDragAndDrop: true,
    toolbar: [
      ["style", ["bold", "italic", "underline", "clear"]],
      ["para", ["ul", "ol", "formatH2"]],
      ["insert", ["table", "hr"]],
      ["misc", ["undo", "redo"]]
    ],
    callbacks: {
      onPaste: function (e) {
          var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
          e.preventDefault();
          document.execCommand('insertText', false, bufferText);
      }
    }
  }).summernote("removeModule", "autoLink");
}

function initArticleSummernote() {
  $(".article-summernote").summernote({
    height: 300,
    placeholder: "Treść Twojego ogłoszenia...",
    lang: "pl-PL",
    minHeight: 300,
    maxHeight: null,
    disableDragAndDrop: true,
    toolbar: [
      [
        "style",
        [
          "bold",
          "italic",
          "underline",
          "clear",
          "superscript",
          "subscript",
          "fontsize",
          "color",
          "forecolor",
          "backcolor",
          "strikethrough"
        ]
      ],
      ["para", ["ul", "ol", "formatH2", "paragraph", "style"]],
      ["insert", ["table", "hr", "picture", "link", "video"]],
      ["misc", ["fullscreen", "undo", "redo", "codeview"]]
    ]
  });
}

function displaySelectricValidationMsg(id, msg, classname) {
  if (!$("#" + id + "-error-2").length) {
    var selectricEl = $("#" + id)
      .closest(".selectric-wrapper")
      .find(".selectric");
    var errorMsg =
      '<label id="' +
      id +
      '-error-2" class="' +
      classname +
      '" for="' +
      id +
      '">' +
      msg +
      "</label>";
    selectricEl.append(errorMsg);
    selectricEl.addClass(classname);
  }
}

function hideSelectricValidationMsg(id, classname) {
  if ($("#" + id + "-error-2").length) {
    var selectricEl = $("#" + id)
      .closest(".selectric-wrapper")
      .find(".selectric");
    $("#" + id + "-error-2").remove();
    selectricEl.removeClass(classname);
  }
}

function initAdButtons() {
  $(".ajax-control-buttons a").on("click", function(e) {
    var type = $(this).attr("data-type");
    var self = this;
    if (type == "edit" || type == "order") return;

    e.preventDefault();

    if (type == "delete") {
      swal({
        title: "Usuwanie ogłoszenia",
        text:
          "Po usunięciu nie będzie możliwości przywrócenia ogłoszenia. Chcesz kontynuować?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak, usuń",
        cancelButtonText: "Nie, anuluj"
      }).then(result => {
        if (result.value) {
          processAdAjax(self, type);
        }
      });
    } else {
      processAdAjax(self, type);
    }
  });
}

function processAdAjax(self, type) {
  var token = $('meta[name="csrf-token"]').attr("content");
  var route = $(self).attr("href");
  var row = $(self).closest(".userAdvertises__item");
  var message = "";

  switch (type) {
    case "subject":
      message = "Ogłoszenie usunięte";
      break;
    case "visibility":
      message = "Widoczność zmieniona";
      break;
    case "bump":
      message = "Data wygaśnięcia zmieniona";
      break;
    default:
      message = "Zmiana zapisana";
      break;
  }

  var data = {
    _token: token
  };

  fetch(route, {
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
      "content-type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-TOKEN": token
    },
    method: "POST"
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.statusText);
      } else {
        toast({
          type: "success",
          title: message
        });

        if (type == "delete") {
          $(row).remove();
        }

        if (type == "visibility") {
          $(row).toggleClass("userAdvertises__item--hidden");
          const btn = $(row).find(
            ".userAdvertises__buttonIconDesc--visibility"
          );

          if ($(row).hasClass("userAdvertises__item--hidden")) {
            $(btn).text($(btn).attr("data-hidden"));
          } else {
            $(btn).text($(btn).attr("data-visible"));
          }
        }

        if (type == "bump") {
          $(row).removeClass("low-time");
          $(row)
            .find(".card-list-date")
            .text("za 29 dni");
        }
      }
    })
    .catch(error => {
      console.log(error);
    });
}

$.validator.addMethod(
  "valueNotEquals",
  function(value, element, arg) {
    return arg !== value;
  },
  "Value must not equal arg."
);



// WEBPACK FOOTER //
// ./resources/assets/js/temp/functions.js